var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Battery_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Battery_",
    "data-name": "Battery ",
    clipPath: "url(#clip-Battery_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "battery",
    transform: "translate(58.223 37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M38.3,10H253.041V40.516H78.566V91.377h33.553L58.435,142.238,4.75,91.377H38.3Z",
    transform: "translate(42.568 110.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M207.466,127.662V54.947H238.32L188.954,9.5,139.587,54.947h30.854v45.447H10v27.268Z",
    transform: "translate(117.756 150.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M325.033,22.222c0-6.378,0-9.568-1.067-12a10.722,10.722,0,0,0-4.278-4.977C317.593,4,314.852,4,309.37,4H262.384c-5.482,0-8.223,0-10.317,1.241a10.722,10.722,0,0,0-4.278,4.977c-1.067,2.436-1.067,5.625-1.067,12V49.555H148.833V22.222c0-6.378,0-9.568-1.067-12a10.727,10.727,0,0,0-4.278-4.977C141.394,4,138.653,4,133.171,4H86.184C80.7,4,77.961,4,75.867,5.241a10.727,10.727,0,0,0-4.278,4.977c-1.067,2.436-1.067,5.625-1.067,12V49.555H41.155C19.424,49.555,2,69.827,2,95.111V322.888c0,25.283,17.424,45.555,39.155,45.555H354.4c21.731,0,39.155-20.272,39.155-45.555l-.2-227.777c0-25.283-17.228-45.555-38.96-45.555H325.033ZM41.155,322.888V95.111l313.048.046.2,227.731Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.172936c99e9a077a492b2a677bd6e078.svg";
export { ForwardRef as ReactComponent };